import React from 'react'
import { Grid, Card, CardContent } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  Card: {
    height: "100%",
  },
  CCUniformPadding: {
    '&:last-child': {
      padding: 16,
    },
  },
}))

export default function GridCard({ children, uniformPadding = false, ...props }) {
  const classes = useStyles()

  return (
    <Grid item {...props}>
      <Card className={classes.Card}>
        <CardContent className={uniformPadding ? classes.CCUniformPadding : null}>{children}</CardContent>
      </Card>
    </Grid>
  )
}
